import styled from 'styled-components';

export const GraphWrapper = styled('div')`
  height: 140px;
`;
